exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".yalmg{opacity:0.5}.lVPpz{margin-left:12px;white-space:nowrap}\n", ""]);

// Exports
exports.locals = {
	"disabled": "yalmg",
	"button": "lVPpz"
};